import { all, put, take } from 'redux-saga/effects';

import { NOTIFICATIONS } from 'PipeRouter';
import goToPageFail from './goToPage';
import getPageBreaksFail from './getPageBreaks';
// import createPageViewer from './createPageViewer';


function* initialize() {
  while (true) {
    const { data } = yield take(NOTIFICATIONS);

    yield put({ type: data.notify, data });
  }
}


function* notifications() {
  yield all([
    initialize(),
    goToPageFail(),
    getPageBreaksFail()
    // createPageViewer()
  ]);
}


export default notifications;
